import React, { useRef, useEffect, useState } from "react";
import Header from "./../components/Header";
import ShopSection from "./../components/homeComponents/ShopSection";
import PortraitsSection from "./../components/homeComponents/PortraitsSection";
import CalltoActionSection from "./../components/homeComponents/CalltoActionSection";
import ContactInfo from "./../components/homeComponents/ContactInfo";
import PlatformsMarquee from "./../components/PlatformsMarquee";
import Footer from "./../components/Footer";
import ImageCarousel from "./../components/ImageCarousel";
import UpcomingEvents from "../components/homeComponents/UpcomingEvents";
import TravelSection from "../components/homeComponents/TravelSection";

const HomeScreen = ({ match }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const keyword = match?.params?.keyword;
  const pagenumber = match?.params?.pagenumber;
  const [isMobile, setIsMobile] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  const shopSectionRef = useRef(null);
  
  useEffect(() => {
    // To check if user is on mobile when component mounts
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    //listener for window resizing
    window.addEventListener('resize', checkMobile);
    
    //scroll listener
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollPosition > 100);
      console.log("Scroll position:", scrollPosition, "Is scrolled:", scrollPosition > 100);
    };
    
    // scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check for scroll position
    handleScroll();
    
    // Clean up
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const handleScrollToShop = () => {
    if (shopSectionRef.current) {
      shopSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  
  // Carousel slides data
  const carouselSlides = [
    {
      image: "/images/header_img1.png",
    },
    {
      image: "/images/headerimage3.png",
    },
    {
      image: "/images/headerimage2.png",
    }
  ];
  
  const animationKeyframes = `
    @keyframes zoomIn {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
        transform: translate(-50%, -40%);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, -50%);
      }
    }
  `;

  return (
    <div>
      <style>
        {animationKeyframes}
        
        {`
          /* Carousel Styles */
          .carousel-container {
            position: relative;
            height: 605px;
            overflow: hidden;
            width: 100%;
          }
          
          .carousel-slides {
            width: 100%;
            height: 100%;
            position: relative;
          }
          
          .carousel-slide {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            transition: opacity 0.5s ease-in-out;
            z-index: -2;
          }
          
          .carousel-slide.active {
            animation: zoomIn 10s ease-in-out infinite;
          }
          
          .carousel-caption {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            width: 100%;
            max-width: 600px;
            padding: 0 20px;
            color: #fff;
            z-index: 1;
            animation: fadeIn 1.2s ease-out forwards;
          }
          
          .carousel-caption h2 {
            font-size: 32px;
            font-weight: 1000;
            letter-spacing: 2px;
            margin-bottom: 10px;
            text-shadow: 0 8px 8px rgba(0,0,0,0.4);
            text-transform: uppercase;
          }
          
          .carousel-caption p {
            font-size: 18px;
            text-shadow: 0 2px 4px rgba(0,0,0,0.6);
          }
          
          /* Dark overlay */
          .carousel-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
            z-index: -1;
          }
          
          /* Shop button styles */
          .button-container {
            bottom: 80px;
            left: 10;
            right: 10;
            display: flex;
            justify-content: center;
            z-index: 10;
          }
          
          .shop-my-art-button {
            background-color: #fff;
            color: #000;
            padding: 12px 24px;
            font-weight: bold;
            font-size: 16px;
            border: none;
            cursor: pointer;
            transition: all 0.3s;
          }
          
          .shop-my-art-button:hover {
            background-color: #f0f0f0;
            transform: translateY(-2px);
          }
          
          /* Mobile structure */
          @media (max-width: 768px) {
            .mobile-center-text {
              display: block !important;
            }
            
            .carousel-caption h2 {
              font-size: 22px;
            }
            
            .carousel-caption p {
              font-size: 16px;
            }
          }
        `}
      </style>

      {/* Pass isHome and isScrolled to the Header */}
      <Header className="header" isHome={!keyword} isScrolled={isScrolled} />
      
      {!keyword && (
        <div className="hero-section">
          {isMobile ? (
            // Mobile view
            <div style={{ position: 'relative', height: '605px', overflow: 'hidden' }}>
              <ImageCarousel slides={carouselSlides} autoRotateTime={5000} />
              
              <div className="mobile-center-text" style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                width: '100%',
                maxWidth: '320px',
                padding: '0 20px',
                display: 'none',
                animation: 'fadeIn 1.2s ease-out forwards',
                zIndex: 10
              }}>
                <h1 style={{
                  fontSize: '22px',
                  color: '#fff',
                  fontWeight: '1000',
                  letterSpacing: '2px',
                  marginBottom: '5px',
                  textShadow: '0 8px 8px rgba(0,0,0,0.4)',
                  textTransform: 'uppercase'
                }}>
                  Moments Captured in Pencil
                </h1>
              </div>
              
              <div className="button-container">
                <button
                  type=""
                  className="shop-my-art-button rounded drop-shadow"
                  onClick={handleScrollToShop}
                >
                  SHOP NOW
                </button>
              </div>
            </div>
          ) : (
            // Desktop/medium view - carousel with captions
            <div className="carousel-container">
              <ImageCarousel slides={carouselSlides} autoRotateTime={5000} />
              
              <div className="button-container">
                <button
                  type=""
                  className="shop-my-art-button rounded drop-shadow"
                  onClick={handleScrollToShop}
                >
                  SHOP NOW
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="shop-intro">
        <h2>Explore the World in Graphite</h2>
        <p>
          Discover the magic of pencil art where imagination meets precision. Each piece tells a unique story through intricate strokes and subtle shading. Dive into a world of monochrome beauty and experience art that resonates with depth and emotion. Explore timeless creations crafted with passion and elegance.
        </p>
        <div className="prints-divider"></div>
      </div>

      <ShopSection
        keyword={keyword}
        pagenumber={pagenumber}
        ref={shopSectionRef}
      />
      <hr className="mt-4 border-white" />
      {!keyword && <PortraitsSection />}
      <hr className="mt-4 border-white" />      
      <CalltoActionSection />
      <UpcomingEvents/>
      <hr className="mt-4 border-white" />
      {!keyword && <TravelSection />}
      <PlatformsMarquee/>
      <hr className="mt-4 border-white" />
      <ContactInfo />
      <hr className="mt-4 border-white" />
      <Footer />
    </div>
  );
};

export default HomeScreen;